export function sortByGroup<T extends { group?: string }>(items: T[]): T[] {
  if (!items.some((item) => item.group)) return items;
  return [...items].sort((a, b) =>
    (a.group ?? '').localeCompare(b.group ?? ''),
  );
}
